import React, { useState } from 'react';

import logosvg from "../../images/logo.svg"
import menusvg from "../../images/icon-hamburger.svg" 
import Closesvg from "../../images/icon-close.svg"

import { Container, Logo, Menu, HamburguerMenu, SloganBox, MenuItem, MenuContainer, Close, MenuDesktop, LogoDesktop, MenuItemDesktop, ItensDesk, SloganDeskBox, MenuOtherDes} from './styles';

function Nav() {
  const [menu, setMenu] = useState(false);

  function AtivarMenu(e){
    setMenu(!menu)
    console.log(menu)
  }
  return (
  <Container>
    <Menu>  
        <Logo src = {logosvg}/>  
        <HamburguerMenu onClick={AtivarMenu} src = {menusvg} />
        <SloganBox>
            <h1>IMMERSIVE EXPERIENCES THAT DELIVER</h1>
        </SloganBox>
    </Menu>
    <MenuDesktop>
        <MenuOtherDes>
          <LogoDesktop src = {logosvg}/> 
          <ItensDesk>  
            <MenuItemDesktop><a href='/'>About</a></MenuItemDesktop>
            <MenuItemDesktop><a href='/'>Careers</a></MenuItemDesktop>
            <MenuItemDesktop><a href='/'>Events</a></MenuItemDesktop>
            <MenuItemDesktop><a href='/'>Products</a></MenuItemDesktop>
            <MenuItemDesktop><a href='/'>Support</a></MenuItemDesktop>
          </ItensDesk> 
        </MenuOtherDes>
        <SloganDeskBox>
            <h1>IMMERSIVE EXPERIENCES THAT DELIVER</h1>
          </SloganDeskBox>
    </MenuDesktop>
    {menu &&
      <MenuContainer >
        <Logo src = {logosvg}/>  
        <Close onClick={AtivarMenu}>X</Close>
        <MenuItem><a href='/'>About</a></MenuItem>
        <MenuItem><a href='/'>Careers</a></MenuItem>
        <MenuItem><a href='/'>Events</a></MenuItem>
        <MenuItem><a href='/'>Products</a></MenuItem>
        <MenuItem><a href='/'>Support</a></MenuItem> 
      </MenuContainer>
    }
  </Container>);
}

export default Nav;